var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('b-card', [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("89.9%")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs my-3",
    attrs: {
      "variant": "success",
      "value": 25
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('b-card', [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("12.124")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs my-3",
    attrs: {
      "variant": "info",
      "value": 25
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('b-card', [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("$98.111,00")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs my-3",
    attrs: {
      "variant": "warning",
      "value": 25
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('b-card', [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("2 TB")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs my-3",
    attrs: {
      "variant": "danger",
      "value": 25
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('b-card', {
    staticClass: "text-white bg-primary"
  }, [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("89.9%")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-white progress-xs my-3",
    attrs: {
      "value": 25
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('b-card', {
    staticClass: "text-white bg-warning"
  }, [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("12.124")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-white progress-xs my-3",
    attrs: {
      "value": 25
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('b-card', {
    staticClass: "text-white bg-danger"
  }, [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("$98.111,00")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-white progress-xs my-3",
    attrs: {
      "value": 25
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('b-card', {
    staticClass: "text-white bg-info"
  }, [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("2 TB")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-white progress-xs my-3",
    attrs: {
      "value": 25
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "card-body p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-primary mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "card-body p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-laptop bg-info p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-info mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "card-body p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-moon-o bg-warning p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-warning mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "card-body p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-bell bg-danger p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-danger mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": "",
      "footer-class": "px-3 py-2"
    }
  }, [_c('div', {
    staticClass: "card-body p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-primary mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('a', {
    staticClass: "font-weight-bold font-xs btn-block text-muted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View More "), _c('i', {
    staticClass: "fa fa-angle-right float-right font-lg"
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": "",
      "footer-class": "px-3 py-2"
    }
  }, [_c('div', {
    staticClass: "card-body p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-laptop bg-info p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-info mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('a', {
    staticClass: "font-weight-bold font-xs btn-block text-muted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View More "), _c('i', {
    staticClass: "fa fa-angle-right float-right font-lg"
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": "",
      "footer-class": "px-3 py-2"
    }
  }, [_c('div', {
    staticClass: "card-body p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-moon-o bg-warning p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-warning mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('a', {
    staticClass: "font-weight-bold font-xs btn-block text-muted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View More "), _c('i', {
    staticClass: "fa fa-angle-right float-right font-lg"
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": "",
      "footer-class": "px-3 py-2"
    }
  }, [_c('div', {
    staticClass: "card-body p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-bell bg-danger p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-danger mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('a', {
    staticClass: "font-weight-bold font-xs btn-block text-muted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View More "), _c('i', {
    staticClass: "fa fa-angle-right float-right font-lg"
  })])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "card-body p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-cogs bg-primary p-4 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-primary mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "card-body p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-laptop bg-info p-4 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-info mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "card-body p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-moon-o bg-warning p-4 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-warning mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "card-body p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-bell bg-danger p-4 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-danger mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "card-body p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-cogs bg-primary p-4 px-5 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-primary mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "card-body p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-laptop bg-info p-4 px-5 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-info mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "card-body p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-moon-o bg-warning p-4 px-5 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-warning mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "card-body p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-bell bg-danger p-4 px-5 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-danger mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-group"
  }, [_c('b-card', [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-people"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("87.500")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Visitors")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs mt-3 mb-0",
    attrs: {
      "variant": "info",
      "value": 25
    }
  })], 1), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-user-follow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("385")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("New Clients")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs mt-3 mb-0",
    attrs: {
      "variant": "success",
      "value": 25
    }
  })], 1), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-basket-loaded"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("1238")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Products sold")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs mt-3 mb-0",
    attrs: {
      "variant": "warning",
      "value": 25
    }
  })], 1), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-pie-chart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("28%")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Returning Visitors")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs mt-3 mb-0",
    attrs: {
      "value": 25
    }
  })], 1), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-speedometer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("5:34:11")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Avg. Time")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs mt-3 mb-0",
    attrs: {
      "variant": "danger",
      "value": 25
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-people"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("87.500")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Visitors")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs mt-3 mb-0",
    attrs: {
      "variant": "info",
      "value": 25
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-user-follow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("385")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("New Clients")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs mt-3 mb-0",
    attrs: {
      "variant": "success",
      "value": 25
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-basket-loaded"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("1238")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Products sold")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs mt-3 mb-0",
    attrs: {
      "variant": "warning",
      "value": 25
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-pie-chart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("28%")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Returning Visitors")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs mt-3 mb-0",
    attrs: {
      "value": 25
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-speedometer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("5:34:11")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Avg. Time")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs mt-3 mb-0",
    attrs: {
      "variant": "danger",
      "value": 25
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-speech"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("972")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs mt-3 mb-0",
    attrs: {
      "variant": "info",
      "value": 25
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', {
    staticClass: "text-white bg-info"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-people"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("87.500")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Visitors")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-white progress-xs mt-3",
    attrs: {
      "value": 25
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', {
    staticClass: "text-white bg-success"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-user-follow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("385")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("New Clients")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-white progress-xs mt-3",
    attrs: {
      "value": 25
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', {
    staticClass: "text-white bg-warning"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-basket-loaded"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("1238")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Products sold")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-white progress-xs mt-3",
    attrs: {
      "value": 25
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', {
    staticClass: "text-white bg-primary"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-pie-chart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("28%")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Returning Visitors")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-white progress-xs mt-3",
    attrs: {
      "value": 25
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', {
    staticClass: "text-white bg-danger"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-speedometer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("5:34:11")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Avg. Time")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-white progress-xs mt-3",
    attrs: {
      "value": 25
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('b-card', {
    staticClass: "text-white bg-info"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-speech"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("972")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-white progress-xs mt-3",
    attrs: {
      "value": 25
    }
  })], 1)], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "social-box facebook"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("89k")]), _vm._v(" "), _c('span', [_vm._v("friends")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("459")]), _vm._v(" "), _c('span', [_vm._v("feeds")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "social-box twitter"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("973k")]), _vm._v(" "), _c('span', [_vm._v("followers")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("1.792")]), _vm._v(" "), _c('span', [_vm._v("tweets")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "social-box linkedin"
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("500+")]), _vm._v(" "), _c('span', [_vm._v("contacts")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("292")]), _vm._v(" "), _c('span', [_vm._v("feeds")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "social-box google-plus"
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("894")]), _vm._v(" "), _c('span', [_vm._v("followers")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("92")]), _vm._v(" "), _c('span', [_vm._v("circles")])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e2aeb0d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Widgets.vue
// module id = 1018
// module chunks = 1